import { useState, useEffect } from 'react'

export default function useIsOnline() {

    const [isOnline, setIsOnline] = useState(true);
    
    useEffect(() => {
        
        function checkOnline() {
            setIsOnline(navigator.onLine);
        }
        
        checkOnline();
        
        window.addEventListener('online', checkOnline);
        window.addEventListener('offline', checkOnline);
        
        return () => {
            window.removeEventListener('online', checkOnline);
            window.removeEventListener('online', checkOnline);
        }
        
    }, []);
    
    return isOnline;
}